/* eslint-disable max-len */
import { getMessage } from '../../translations';
import { getUserFromLocalStorage } from '../../component/utils/user';
const userLang = getUserFromLocalStorage();
const languageCode = userLang?.language?.toLowerCase().startsWith('en') ? 'en' : userLang?.language?.toLowerCase() || 'default-language';

export const getTransportRatesImporterSetting = ({
  qualityGroupDropdownData,
  currenciesAbbrDropdownData,
  volumeUnitDropdownData,
  transportModeDropdownData,
  logisticMaterialsDropdownData,
  logisticForwardersDropdownData,
}) => ({
  //multipleFileUpload: true,
  developerMode: false,
  identifier: 'transport',
  language: languageCode,
  allowManualInput: true,
  i18nOverrides: {
    txt_back_page_dialog: getMessage(
      'If you press the "Go back" button, you will lose the progress of the current step.'
    ),
    txt_close_page_modal: getMessage(
      'If you press the "Go back" button, you will lose the entire progress of all steps.'
    ),
    txt_confirm_submit_data_with_error: getMessage(
      "Are you sure you want to submit your data? Rows with an error won't be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button"
    ),
    txt_confirm_submit_data_without_error: getMessage(
      'Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button'
    ),
    txt_allow_error_confirm_submit_data_with_error: getMessage(
      'Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button'
    ),
    txt_import_data_error_exceed: getMessage(
      'Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button.'
    ),
  },
  columns: [
    {
      key: 'qualityGroup',
      label: getMessage('Material group'),
      description: getMessage('Material group'),
      example: 'Ferrous',
      columnType: 'category',
      dropdownOptions: qualityGroupDropdownData,
      alternativeMatches: ['Material group', 'Quality group'],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Material group shouldn't be left blank"),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'comment',
      label: getMessage('Comment'),
      description: getMessage('Comment'),
      example: 'testing',
      columnType: 'string',
      alternativeMatches: ['Comment'],
    },
    {
      key: 'cost',
      label: getMessage('cost'),
      description: getMessage('cost'),
      example: '250',
      columnType: 'float',
      alternativeMatches: ['Transport cost','cost'],
    },
    {
      key: 'costCurrency',
      label: getMessage('Cost currency'),
      description: getMessage('Transport cost currency code'),
      example: 'USD',
      columnType: 'category',
      dropdownOptions: currenciesAbbrDropdownData,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Transport currency shouldn't be left blank"),
        },
      ],
      isMultiSelect: false,
      alternativeMatches: ['Transport currency','cost currency'],
    },
    {
      key: 'costVolume',
      label: getMessage('Cost volume'),
      description: getMessage('Cost volume'),
      example: 'CTN',
      columnType: 'category',
      dropdownOptions: volumeUnitDropdownData,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Cost volume shouldn't be left blank"),
        },
      ],
      isMultiSelect: false,
      alternativeMatches: ['Cost volume','Transport currency volume'],
    },
    {
      key: 'logisticForwarder',
      label: getMessage('Logistic forwarder'),
      description: getMessage('Logistic forwarder'),
      example: 'GASTOS MARITIMOS',
      columnType: 'category',
      dropdownOptions: logisticForwardersDropdownData,
      isMultiSelect: false,
      alternativeMatches: ['Logistic forwarder'],
      
    },
    {
      key: 'logisticMaterial',
      label: getMessage('Logistic material'),
      description: getMessage('Logistic material'),
      example: '40HC or 20HC',
      columnType: 'category',
      dropdownOptions: logisticMaterialsDropdownData,
      isMultiSelect: false,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Cost volume shouldn't be left blank"),
        },
      ],
      alternativeMatches: ['Logistic material', 'logistic material', 
        'Transport type', 'Transport type/Logistic material'],
    },
    {
      key: 'preCarriageLine',
      label: getMessage('Carrier'),
      description: getMessage('Carrier'),
      example: 'GASTOS MARITIMOS',
      columnType: 'string',
      alternativeMatches: ['Carrier','Pre carriage line'],
    },
    {
      key: 'preCarriageArea',
      label: getMessage('Loading area'),
      description: getMessage('Loading area'),
      example: 'Amsterdam',
      columnType: 'string',
      alternativeMatches: ['Loading area', 'Pre carriage area'],
    },
    {
      key: 'destinationArea',
      label: getMessage('Destination area'),
      description: getMessage('Destination area'),
      example: 'Amsterdam',
      columnType: 'string',
      alternativeMatches: ['Destination area'],
    },
    
    {
      key: 'mode',
      label: getMessage('Transport mode'),
      description: getMessage('Transport mode'),
      example: 'ROAD',
      columnType: 'category',
      dropdownOptions: transportModeDropdownData,
      isMultiSelect: false,
      alternativeMatches: ['Mode', 'mode', 'Transport mode'],
    },
    
    {
      key: 'lastValidityDate',
      label: getMessage('Last validity date'),
      description: getMessage('Last validity date'),
      example: '2023-07-22T15:52:45.175Z',
      columnType: 'date',
      outputFormat: 'YYYY-MM-DD',
      alternativeMatches: ['Last validity date'],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage('Last validity date cannot be left blank'),
        },
      ],
    },
    {
      key: 'firstValidityDate',
      label: getMessage('First validity date'),
      description: getMessage('First validity date'),
      example: '2023-07-22T15:52:45.175Z',
      columnType: 'date',
      outputFormat: 'YYYY-MM-DD',
      alternativeMatches: ['First validity date'],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage('First validity date cannot be left blank'),
        },
      ],
    },
  ],
});
